import { useNavigate } from "react-router-dom";
import type { ModuleDef } from "@shared/modules.ts";
import { Icon } from "../lib/icons.tsx";

/**
 * Honest interim page for modules delivered in a later milestone.
 * NOT a fake "Coming Soon" for a finished feature — it clearly states the
 * milestone and what the module will do, per the build plan.
 */
export default function ModuleStub({ module }: { module: ModuleDef }) {
  const nav = useNavigate();
  return (
    <div className="page">
      <div className="page__head">
        <div className="page__title">{module.label} <span className="mh-eng mh-muted" style={{ fontSize: 16 }}>({module.en})</span></div>
        <div className="page__subtitle">{module.desc}</div>
      </div>

      <div className="empty">
        <div className="empty__icon"><Icon name={module.icon} size={30} /></div>
        <h3>โมดูลนี้อยู่ใน Milestone {module.milestone}</h3>
        <p className="mh-sec" style={{ maxWidth: 460 }}>
          โครงสร้างข้อมูล (Database) และ AI Agent ของโมดูลนี้ถูกวางไว้เรียบร้อยแล้ว —
          กำลังต่อหน้าจอใช้งานจริงตามลำดับ Milestone จะไม่มีปุ่มหลอกหรือผลลัพธ์ปลอม
        </p>
        <div style={{ display: "flex", gap: 10, marginTop: 6 }}>
          <button className="mh-btn mh-btn--primary" onClick={() => nav("/advisor")}><Icon name="Sparkles" size={18} /> ใช้ AI Advisor ก่อน</button>
          <button className="mh-btn mh-btn--ghost" onClick={() => nav("/")}>กลับแดชบอร์ด</button>
        </div>
      </div>
    </div>
  );
}
